export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de pallets"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modificar pallet"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "add_assigned_package_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asignar paquete existente"])}
        }
      }
    }
  })
}